import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, of, Subject, takeUntil } from 'rxjs';
import { AccountService } from 'src/app/services/account.service';
import { MapService } from 'src/app/services/map.service';
import { OtherService } from 'src/app/services/other.service';
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';


@Component({

  selector: 'app-work-profile',

  templateUrl: './work-profile.component.html',

  styleUrls: ['./work-profile.component.css'],

})

export class WorkProfileComponent implements OnInit {

  @ViewChild('paymentDialogTemplate') paymentDialogTemplate: TemplateRef<any>;

  @ViewChild('tankerInvoiceDialogTemplate') tankerInvoiceDialogTemplate: TemplateRef<any>;

  @ViewChild('tankerLicenseDialogTemplate') tankerLicenseDialog: TemplateRef<any>;

  private forcePayment: boolean = (<any>window).forcePayment;

  private persianRegex = /^[\u0600-\u06FF\s]$/;

  activeAccordion: 1 | 2 = 1;

  Info: any;

  lst_States: any = [];

  list_City: any = [];

  lst_FloatingType: any = [];

  openMap: boolean = false;

  carTypes$ = this.accountService.tankerGPSType().pipe(
    map((response: string) => JSON.parse(response)),
    catchError(() => of(false)),
  );

  forceAddress: boolean = false;

  addressPlaceHolder: string = '';

  mdl_User = this.formBuilder.group({
    iPreregistration: new FormControl(''),
    strSession: new FormControl(''),
    strName: new FormControl('', Validators.required),
    strFamily: new FormControl('', Validators.required),
    strID: new FormControl('', Validators.required),
    strState: new FormControl('', Validators.required),
    strCity: new FormControl('', Validators.required),
    strMobile: new FormControl('', Validators.required),
    strTel: new FormControl('', Validators.required),
    fLat: new FormControl(0),
    fLon: new FormControl(0),
    strComment: new FormControl(''),
    strAddress: new FormControl(''),
    strRegisterDateTime: new FormControl({ value: '', disabled: true }),
    strAnnouncementTime: new FormControl({ value: '', disabled: true }),
    strMobile1: new FormControl({ value: '', disabled: true }),
    strFullName: new FormControl({ value: '', disabled: true }),
    strInstallDate: new FormControl({ value: '', disabled: true }),
    strInstallerComment: new FormControl({ value: '', disabled: true }),
    strInstallationStatus: new FormControl(''),
    tiInstallationStatus: new FormControl(''),
    strVIN: new FormControl(''),
    strLicenseNo: new FormControl(''),
    // strVehicleNo: new FormControl('', Validators.required),
    strLicenseImage: new FormControl(''),
    tiGPSType: new FormControl(null, Validators.required),
    plak4: new FormControl('', [Validators.required, Validators.maxLength(2), Validators.pattern(/^[1-9][0-9]$/)]),
    plak3: new FormControl('', [Validators.required, Validators.maxLength(3), Validators.pattern(/^[1-9][0-9][0-9]$/)]),
    plak2: new FormControl('', [Validators.required]),
    plak1: new FormControl('', [Validators.required, Validators.maxLength(2), Validators.pattern(/^[1-9][0-9]$/)]),
  });

  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });

  mdl_Payment: FormGroup = this.formBuilder.group({

    iResult: new FormControl(''),

    strURL: new FormControl(''),

  });

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private otherService: OtherService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private _MapService: MapService,
    private ngbModal: NgbModal,
    private title: Title
  ) {

    this.addressPlaceHolder = this.forceAddress ? '* آدرس محل نصب (الزامی)' : 'آدرس محل نصب (اختیاری)';


  }

  ngOnInit(): void {

    if (this.forceAddress) {

      const address = this.mdl_User.get('strAddress');
      address?.addValidators(Validators.required);
      address?.updateValueAndValidity();

      const fLat = this.mdl_User.get('fLat');
      fLat?.addValidators(Validators.required);
      fLat?.updateValueAndValidity();

      const fLon = this.mdl_User.get('fLon');
      fLon?.addValidators(Validators.required);
      fLon?.updateValueAndValidity();

    }

    this.title.setTitle('پروفایل کاربری | TankerGPS - ردیاب تانکر های آبرسان');

    this.Info = this.otherService.getLocalStorage();

    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.userInfo(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((userData: string) => {

      let res = JSON.parse(userData);

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      Object.keys(res[0]).forEach((key) => {
        this.mdl_User.get(key)?.setValue(res[0][key]);
      });

      this.buildVehicleNo(res[0]);

      this.getCity(res[0].strState);

      const status = this.mdl_User.get('tiInstallationStatus').value || 0;

      this.activeAccordion = status < 3 ? 2 : 1;

      this.mdl_User.patchValue({
        iPreregistration: this.Info.Id,
        strSession: this.Info.session,
      });

      this.mdl_Payment.patchValue({
        iResult: status
      });

      this.mdl_User.get('strID')?.disable();

      this.mdl_User.get('strMobile')?.disable();

      if (status > 2) {

        this.mdl_User.disable();
      }

      if (status == 0 && this.forcePayment) {

        this.showAlert();

      }

    });

    this.accountService.GetState().pipe(takeUntil(this.unSubscribeAll$)).subscribe((response) => {
      let res = JSON.parse(response.toString());
      this.lst_States = res;
    });

    this.accountService.floatingType().pipe(takeUntil(this.unSubscribeAll$)).subscribe((response) => {
      let res = JSON.parse(response.toString());
      this.lst_FloatingType = res;
    });
  }

  ngOnDestroy(): void {

    this.unSubscribeAll();

  }

  buildVehicleNo(response) {

    const objVehicleNo = response.strVehicleNo.split(' ');

    this.mdl_User.patchValue({

      plak4: objVehicleNo[4],

      plak3: objVehicleNo[2],

      plak2: objVehicleNo[1],

      plak1: objVehicleNo[0]

    })


  }

  isOpen(accordion: 1 | 2) {
    return this.activeAccordion === accordion;
  }

  getCity(id) {
    this.accountService.GetCity(id).pipe(takeUntil(this.unSubscribeAll$)).subscribe((response: any) => {
      let res = JSON.parse(response.toString());
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);
      this.list_City = res;
    });
  }

  show_Map() {
    let model = this.mdl_User.value;

    if (model.strAddress == '') {
      this._MapService.getCurrentLocation().then(coords => {
        this.mdl_Map.patchValue({
          strAddress: model.strAddress,
          fLon: coords.longitude || 0,
          fLat: coords.latitude || 0,
          strSource: 'strAddress',
        });

        this.openMap = true;
      }).catch(error => {
        this.mdl_Map.patchValue({
          strAddress: model.strAddress,
          fLon: model.fLon || 0,
          fLat: model.fLat || 0,
          strSource: 'strAddress',
        });

        this.openMap = true;
        console.error('Error getting location:', error);
      });
    } else {
      this.mdl_Map.patchValue({
        strAddress: this.baseAddress(),
        fLon: model.fLon || 0,
        fLat: model.fLat || 0,
        strSource: 'strAddress',
      });

      this.openMap = true;
    }
  }

  baseAddress(): string {
    const { strCity, strAddress } = this.mdl_User.value;

    const cityObj = this.list_City.find(c => c.strCity === strCity);

    if (!cityObj) return strAddress?.trim() ?? '';

    const cityName = cityObj.strCityName?.trim();

    if (!cityName) return strAddress?.trim() ?? '';

    const normalizedAddress = strAddress?.trim() ?? '';

    if (normalizedAddress.startsWith(cityName)) {

      return normalizedAddress;

    }

    return `${cityName}، ${normalizedAddress}`;

  }

  tankerInvoiceData;
  tankerInvoice() {
    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.tankerInvoice(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((response: string) => {
      let res = JSON.parse(response);
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.tankerInvoiceData = JSON.parse(res.strDetail);
    });
    const dialogRef = this.ngbModal.open(this.tankerInvoiceDialogTemplate, { scrollable: true, container: 'app-work-profile', modalDialogClass: 'payment-dialog', centered: true, animation: false });
    dialogRef.dismissed.subscribe(() => {
      this.tankerInvoiceData = null;
    });
  }

  submitMap(event: any) {
    this.openMap = false;

    if (event.strText != '') {
      this.mdl_User.patchValue({
        strAddress: event.strText,
        fLon: event.longitude,
        fLat: event.latitude,
      });
    } else {
      this.mdl_User.patchValue({
        strAddress: '',
        fLon: 0,
        fLat: 0,
      });
    }
  }

  preInvoiceDetail;
  showAlert() {
    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.preInvoiceDetail(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((response: string) => {
      const res = JSON.parse(response);
      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

      this.preInvoiceDetail = JSON.parse(res.strDetail);
    });

    const dialogRef = this.ngbModal.open(this.paymentDialogTemplate, { scrollable: true, container: 'app-work-profile', modalDialogClass: 'payment-dialog', centered: true, animation: false, backdrop: 'static', keyboard: false });
    dialogRef.dismissed.subscribe(() => {
      this.preInvoiceDetail = null;
    });
  }

  paymentProcess() {

    var model = {
      iPreregistration: this.Info.Id,
      strSession: this.Info.session,
    };

    this.accountService.payInvoice(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((userData) => {
      let res = JSON.parse(userData.toString());

      if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);
      this.mdl_Payment.patchValue({
        strURL: res.strURL
      });

      window.open(this.mdl_Payment.get('strURL')?.value, '_self', '');
    });

  }

  openUrl() {

    const paymentUrl = this.mdl_Payment.get('strURL')?.value;

    if (paymentUrl) {

      window.open(paymentUrl, '_self');

      return

    }

    else {

      var model = {

        iPreregistration: this.Info.Id,

        strSession: this.Info.session,

      };

      this.accountService.payInvoice(model).pipe(takeUntil(this.unSubscribeAll$)).subscribe((userData) => {

        let res = JSON.parse(userData.toString());

        if (res.iResult == 0) {

          return this.accountService.toastSwal('error', res.strError);

        }

        this.mdl_Payment.patchValue({

          strURL: res.strURL

        });

        window.open(res.strURL, '_self', '');

      });

    }

  }

  update_Info() {

    let model = this.mdl_User.getRawValue();;

    this.markAllAsTouched(this.mdl_User);

    if (this.mdl_User.invalid) {

      return this.accountService.toastSwal('error', 'فیلدهای ضروری را وارد کنید');

    }

    if (this.forceAddress && (model.fLat == 0 || model.fLon == 0)) {

      return this.accountService.toastSwal('error', 'آدرس را از روی نقشه انتخاب کنید');

    }

    else {

      Swal.fire({

        title: 'آیا از ویراش اطلاعات اطمینان دارید؟',

        icon: 'warning',

        showCancelButton: true,

        showConfirmButton: true,

        reverseButtons: true,

        confirmButtonColor: '#10b981',

        confirmButtonText: 'تایید',

        cancelButtonText: 'انصراف',

      }).then((result) => {

        if (result.isConfirmed) {

          model.strVehicleNo = `${model.plak1} ${model.plak2} ${model.plak3} | ${model.plak4}`;

          delete model.plak1;

          delete model.plak2;

          delete model.plak3;

          delete model.plak4;

          this.accountService.update_UserInfo(this.otherService.stringNumberToNumber(model)).pipe(takeUntil(this.unSubscribeAll$)).subscribe((data) => {

            let res = JSON.parse(data.toString());

            if (res.iResult == 0) return this.accountService.toastSwal('error', res.strError);

            this.accountService.toastSwal('success', 'اطلاعات با موفقیت ویرایش شد');

          });

        }

      });

    }

  }

  onFileSubmit(event) {

    if (event.strFile) {

      const reader: any = new FileReader();

      reader.readAsDataURL(event.strFile);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.mdl_User.patchValue({

          strLicenseImage: base64String.replace('data:image/jpeg;base64,', ''),

        })

      };

    }

    else {

      this.mdl_User.patchValue({

        strLicenseImage: ''

      })

    }

  }

  onlyNumber(e: KeyboardEvent) {

    if (e.ctrlKey || e.metaKey || /[0-9]/.test(e.key) || ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {

      return;

    }

    e.preventDefault();
  }

  onlyPersian(e: KeyboardEvent) {

    const controlKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Home',
      'End'
    ];

    if (e.ctrlKey || e.metaKey || controlKeys.includes(e.key)) {
      return;
    }

    if (!this.persianRegex.test(e.key)) {

      e.preventDefault();

    }


  }

  sanitizePersian(e: any) {
    const value = e.target.value;
    e.target.value = value.replace(/[^\u0600-\u06FF\s]/g, '');

  }

  saveShot() {

    const element = document.getElementById('payment-receipt');

    if (!element) return;

    html2canvas(element, {

      scale: 2,

      useCORS: true,

      ignoreElements: (el) => {

        return el.classList.contains('receipt-title');

      }

    }).then(canvas => {

      const link = document.createElement('a');

      link.download = `receipt-${Date.now()}.png`;

      link.href = canvas.toDataURL('image/png');

      link.click();

    });

  }

  dismiss(reason: string): void {

    this.ngbModal.dismissAll();

  }

  viewLicense() {

    const dialogRef = this.ngbModal.open(this.tankerLicenseDialog, {

      scrollable: true,

      // size: 'xl',

      container: 'app-work-profile',

      modalDialogClass: 'payment-dialog',

      centered: true,

      animation: false

    });

    dialogRef.dismissed.subscribe(() => {

      this.tankerInvoiceData = null;

    });

  }

  viewFullScreen() {

    const base64 = this.mdl_User.get('strLicenseImage').value;

    const byteCharacters = atob(base64);

    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {

      byteNumbers[i] = byteCharacters.charCodeAt(i);

    }

    const byteArray = new Uint8Array(byteNumbers);

    const blob = new Blob([byteArray], { type: 'image/jpeg' });

    const url = URL.createObjectURL(blob);

    window.open(url, '_blank');

  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }

  unSubscribeAll(): void {

    this.unSubscribeAll$.next();

    this.unSubscribeAll$.complete();

  }

}